import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import './SlideToggle.scss';

const SlideToggle = props => {
	const { screenReaderText, leftItem, rightItem, value, callback } = props;
	const [id] = useState(uniqueId('slide-toggle-'));

	return (
		<>
			<span id={id} className="sr-only">{screenReaderText}</span>
			<button type="button" className="slide-toggle-button p-0" aria-labelledby={id} onClick={callback}>
				<span aria-hidden className={`slide-toggle-button-label ${value === leftItem.value ? 'selected' : ''}`}>{leftItem.label}</span>
				<span aria-hidden className={`slide-toggle-button-label ${value === rightItem.value ? 'selected' : ''}`}>{rightItem.label}</span>
				<span aria-hidden className={`slide-toggle-button-background ${value === leftItem.value ? 'left' : 'right'}`} />
			</button>
		</>
	);
};

SlideToggle.propTypes = {
	screenReaderText: PropTypes.string.isRequired,
	leftItem: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string
	}).isRequired,
	rightItem: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string
	}).isRequired,
	value: PropTypes.string.isRequired,
	callback: PropTypes.func.isRequired
};

export default SlideToggle;
